import { generatePath, useNavigate } from 'react-router';
import { toast } from 'sonner';
import { useCreateRecruitmentContext } from '../../Create/Contexts/CreateRecruitmentContext';
import StepProps from '../StepProps';
import IdentifyExperienceErrorDialog from './Components/IdentifiyExperienceErrorDialog';
import IdentifyExperienceStep from './IdentifyExperienceStep';
import type { IdentifyExperienceFormValues } from './IdentifyExperienceStep.schema';
import { mapRhfCriteriaToExperienceCriteria } from './IdentifyExperienceStepUtils';
import { useNotificationContext } from '@/Context/NotificationContext';
import useClientIdPathParam from '@/Hooks/UseClientIdPathParam';
import useCompanyId from '@/Hooks/UseCompanyId';
import RoutePath from '@/Routing/RoutePath';
import UIStrings from '@/Utils/UIStrings';

const CreateIdentifyExperienceStep = ({ activeStep, handleBack }: StepProps) => {
    const navigate = useNavigate();
    const companyId = useCompanyId();
    const clientId = useClientIdPathParam();
    const { showFailToaster } = useNotificationContext();

    const {
        processingState,
        experienceCriteriaProcessingState,
        experienceCriteria,
        setExperienceCriteria,
        resetExperienceCriteriaProcessingState,
        createRecruitmentAsync,
    } = useCreateRecruitmentContext();

    const onSubmit = async ({ criteria }: IdentifyExperienceFormValues) => {
        try {
            await createRecruitmentAsync(clientId, criteria.map(mapRhfCriteriaToExperienceCriteria));

            // navigate to client recruitment overview.
            const createRecruitmentPath = generatePath(RoutePath.AssessmentsActive, { companyId, clientId });
            navigate(createRecruitmentPath);
            toast.success(UIStrings.RecruitmentHasBeenCreatedTitle, {
                description: UIStrings.RecruitmentHasBeenCreatedDescription,
                descriptionClassName: 'text-foreground!',
                style: { whiteSpace: 'pre-line' },
                duration: 10000,
            });
        } catch (error) {
            showFailToaster();
        }
    };

    return (
        <>
            <IdentifyExperienceErrorDialog />
            <IdentifyExperienceStep
                activeStep={activeStep}
                handleBack={handleBack}
                processingState={processingState}
                experienceCriteriaProcessingState={experienceCriteriaProcessingState}
                experienceCriteria={experienceCriteria}
                setExperienceCriteria={setExperienceCriteria}
                resetExperienceCriteriaProcessingState={resetExperienceCriteriaProcessingState}
                onSubmit={onSubmit}
                isEditMode={false}
            />
        </>
    );
};

export default CreateIdentifyExperienceStep;
